import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { StyledDropdownButton } from '../../../../../components/Dropdown/styles';

export const StyledAccountDropdownButton = styled(StyledDropdownButton)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 12px 8px 12px 16px;
  max-height: 40px;
  border-radius: 3px;
  background: ${colorsPalettes.carbon[0]};
  border: 1px solid ${colorsPalettes.midnight[50]};
`;

export const StyledButtonContent = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[400])};
  display: block;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  width: 100%;
  min-width: 0;
`;
